import { combineReducers } from '@reduxjs/toolkit';

import operationsProducersSlice from '@/shared/redux/slices/operationProducers-slice';

import aipReducer from './aipSync/reducer';
import insuranceAgenciesReducer from './insuranceAgencies/reducer';
import insuranceAgentsReducer from './insuranceAgents/reducer';
import operationsReducer from './operations/slice';
import { userPreferencesReducer } from './preferences/reducer';
import producerOperationReducer from './producerOperations/reducer';
import producersReducer from './producers/reducer';

export const adminRootReducer = combineReducers({
  insuranceAgencies: insuranceAgenciesReducer,
  aip: aipReducer,
  insuranceAgents: insuranceAgentsReducer,
  producers: producersReducer,
  operations: operationsReducer,
  operationsProducers: operationsProducersSlice,
  userPreferences: userPreferencesReducer,
  producerOperations: producerOperationReducer
});
